export const kgDecimals = 0;
export const tonneDecimals = 2;
export const tabNames = {
  ultra_tab_1: 'ultra_tab_1',
  mega_tab_2: 'mega_tab_2',
};
